import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faArchive} from '@fortawesome/pro-solid-svg-icons';
import {AttributeUploadEvent} from './constants';
import {canUploadAttributes} from '../enablers';
import {AttributeUploadActionLabel} from '../locales';

export const attributeUploadActionRouteIcon = faArchive;

/**
 * Route to upload attributes
 * @param params
 * @returns Action
 */
export const attributeUploadActionRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'attribute-upload-route',
	cb: () => dispatcher.trigger(AttributeUploadEvent.UPLOAD),
	enableTest: () => canUploadAttributes(),
	icon: attributeUploadActionRouteIcon,
	get label() {
		return AttributeUploadActionLabel.ROUTE;
	},
	...params,
});
